import { compareValues } from "@sscs/utils";
export function getSortedVulnerabilityReferences(references) {
    return Object.keys(references.references).sort((first, second) => {
        const firstCounts = references.references[first].statistics.counts;
        const secondCounts = references.references[second].statistics.counts;
        if (firstCounts.critical || secondCounts.critical) {
            return compareValues(firstCounts.critical, secondCounts.critical, true);
        }
        else if (firstCounts.high || secondCounts.high) {
            return compareValues(firstCounts.high, secondCounts.high, true);
        }
        else if (firstCounts.medium || secondCounts.medium) {
            return compareValues(firstCounts.medium, secondCounts.medium, true);
        }
        else {
            return compareValues(firstCounts.low, secondCounts.low, true);
        }
    });
}
//# sourceMappingURL=utils.js.map